<template>
	<div role="progressbar" class="mdc-linear-progress" :class="{'mdc-linear-progress--hidden': !visible}" aria-label="Progress Bar" aria-valuemin="0" aria-valuemax="1" aria-valuenow="0">
		<div class="mdc-linear-progress__buffer">
			<div class="mdc-linear-progress__buffer-bar"></div>
			<div class="mdc-linear-progress__buffer-dots"></div>
		</div>
		<div class="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
			<span class="mdc-linear-progress__bar-inner"></span>
		</div>
		<div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
			<span class="mdc-linear-progress__bar-inner"></span>
		</div>
	</div>
</template>

<script>
import { MDCLinearProgress } from '@material/linear-progress'

export default {
	name: 'LinearProgress',
	data: () => ({
		indicator: null,
	}),
	props: {
		progress: Number,
		visible: {
			type: Boolean,
			default: true,
		},
	},
	mounted() {
		this.indicator = new MDCLinearProgress(document.querySelector('.mdc-linear-progress'));
		this.indicator.determinate = true
	},
	watch: {
		progress(newVal) {
			if (this.indicator)
				this.indicator.progress = newVal
		},
	},
}
</script>

<style scoped lang="scss">
@use '@material/linear-progress/mdc-linear-progress';
// @include bar-color('#a7dcf5');
.mdc-linear-progress {

	opacity: 1;
	transition: opacity 250ms linear;

	&--hidden {
		opacity: 0;
		pointer-events: none;
	}

	&__bar-inner {
		border-color: #a7dcf5;
	}

	&__buffer-bar {
		background-color: rgba(0, 0, 0, 0.1);
	}
}
</style>
